import React from 'react';
import { Flame } from 'lucide-react';
import { cn } from '../lib/utils';

export const StreakWidget = ({ streak }) => {
  if (!streak) return null;
  const { current_streak, best_streak, today_done, today_total, today_complete } = streak;
  const remaining = today_total - today_done;

  return (
    <div
      className="w-full sm:w-56 rounded-2xl border border-[#EEEAE0] bg-white p-5 shadow-sm"
      data-testid="streak-widget"
    >
      <div className="flex items-center gap-2 mb-3">
        <div className={cn(
          "w-8 h-8 rounded-lg flex items-center justify-center transition-colors duration-300",
          current_streak > 0 ? "bg-[#FDF0EC]" : "bg-[#F4F3EE]"
        )}>
          <Flame className={cn("w-4 h-4", current_streak > 0 ? "text-coral" : "text-[#9E8778]")} />
        </div>
        <span className="sl-section-tag">DAILY STREAK</span>
      </div>
      <p className="text-4xl font-semibold tracking-[-0.03em] text-[#1A1A1A]" data-testid="streak-current">
        {current_streak}
        <span className="ml-1.5 text-base font-medium text-[#9E8778]">{current_streak === 1 ? 'day' : 'days'}</span>
      </p>
      <div className="mt-3 h-1.5 rounded-full bg-[#F4F3EE] overflow-hidden">
        <div
          className="h-full rounded-full bg-[#E16246] transition-[width] duration-500"
          style={{ width: today_total ? `${(today_done / today_total) * 100}%` : '0%' }}
        />
      </div>
      <p className="mt-2 text-xs text-[#5F5F5F]" data-testid="streak-today">
        {today_total === 0
          ? 'Add a goal to start a streak'
          : today_complete
            ? 'All goals checked in today'
            : `${today_done}/${today_total} checked in · ${remaining} to go`}
      </p>
      <p className="mt-1 text-xs text-[#9E8778]" data-testid="streak-best">Best: {best_streak} {best_streak === 1 ? 'day' : 'days'}</p>
    </div>
  );
};
